
















































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { MAudio } from "@/utils/audio";
import PlayLottie from '@/views/searchSpeaker/components/playLottie/playLottie.vue';

@Component({
  components: {
    PlayLottie
  },
  watch:{
    selectedValue(){
      this.playState === 'initial';
    }
  }
})
export default class ChooseStyle extends Vue {
  @Prop({ default: () => [] })
  speakerEmotionCacheVOList: Array<any>;
  @Prop({ default: '' })
  speakerId: string;

  selectedValue: any = this.$props.speakerId||''; //当前选中的风格
  playState = "initial";// initial 初始态，没有播放   playing 正在播放    paused 暂停中
  speakerAudio = null;
  VOICE_CACHE = {};
  created(moduleData: IinjectDatas) {
    this.speakerAudio = MAudio.listen({//试听发音人声音
      playing: () => {
        this.playState = "playing";
      },
      pause: () => {
        this.playState = "paused";
        console.log('---当前播放状态',this.playState)
      },
      ended: () => {
        this.playState = "initial";
      }
    });
  }
  mounted(){
    console.log('-选择风格',this.$props.speakerEmotionCacheVOList,this.$props.speakerId)
  }
  @Watch('speakerId', {})
  listenSpeakerId(val) {
    this.selectedValue = val;
  }
  onPick(moodSpeaker,idx) {
    console.log('---moodSpeaker',[this.selectedValue,moodSpeaker.speakerId])
    if (this.selectedValue === moodSpeaker.speakerId) {
      if (this.playState === 'initial') {
        // 重新开始播放
        this.playAudio(this.selectedValue,idx);
        
      } else if (this.playState === 'paused') {
        // 继续播放
        this.speakerAudio.play();
        this.playState = 'playing'
      } else if (this.playState === 'playing') {
        console.log('---暂停播放')
        // 暂停播放
        this.speakerAudio.pause();
        this.playState = 'paused';
      }
      return;
    }

    this.selectedValue = moodSpeaker.speakerId;

    // 重置播放器状态
    // this.resetAudio();//todo

    // 试听
    this.playAudio(this.selectedValue,idx);
    console.log('---this.selectedValue',this.selectedValue)
    let selectedName = moodSpeaker.name.split("|")[1];
    // this.$emit('onPickStyle',this.selectedValue,selectedName)
    //保存当前发音人(包含了具体风格的发音人)
    this.$emit('onPickStyle',moodSpeaker)
  }
  playAudio(speakerId,idx) {
    let demoUrl = this.speakerEmotionCacheVOList[idx].demoUrl;
    if(demoUrl){
      this.speakerAudio.setSrc(demoUrl);
      this.speakerAudio.play();
      this.playState ='playing';
    }
  }
  stopPlay(){
    this.speakerAudio.setSrc('');
    this.playState ='initial';
  }

    //重置播放器状态
  resetAudio() {
    this.playState = "initial";
    this.speakerAudio && this.speakerAudio.setSrc("");
    this.speakerAudio && this.speakerAudio.stop();
  }
  // onConfirm() {
  //   if (this.selectedValue !== this.$props.value) {
  //     this.$emit("change", {
  //       value: this.selectedValue,
  //       option: this.$props.options.find((item) => item.id === this.selectedValue),
  //     });
  //   }
  // }
}
